import React from 'react'
import Link from 'gatsby-link'
import { Route, Redirect } from "react-router-dom";
import SurveyPage from './survey';
import ThankYouPage from './thankyou';
import NotFoundPage from './404';

class IndexPage extends React.Component {
  render () {
    return (
      <div>
        <Route
         render={({ location }) => (
           <div>
             <Route
               location={location}
               key={location.key+'no'}
               exact
               path="/"
               render={() => <Redirect to="/n/no_id" />}
             />
             <Route
               location={location}
               key={location.key+'ty'}
               exact
               path="/thankyou"
               component={ThankYouPage}
             />
             <Route
               location={location}
               key={location.key+'sn'}
               path="/"
               render={({location})=>(
                 <Route
                   location={location}
                   key={location.key+'4'}
                   path="/:emotion/:agent_id"
                   component={SurveyPage}
                 />
                )}
             />
           </div>
         )}
         />
       </div>
  )
  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js